import { Component, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    imports: [MatButtonModule, TranslateModule],
    selector: 'app-update-prompt',
    templateUrl: './update-prompt.component.html',
    styleUrls: ['./update-prompt.component.scss']
})
export class UpdatePromptComponent {
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onReload = new EventEmitter<void>();
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onDismiss = new EventEmitter<void>();

    reload() { this.onReload.emit(); }
    dismiss() { this.onDismiss.emit(); }
}
